const INITIAL_STATE = { productName: '', productDescription: '', productLink: '', productPictureLink: '', productMessage: '' };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_NAME_CHANGE':
            return { ...state, productName: action.payload };
        case 'PRODUCT_DESCRIPTION_CHANGE':
            return { ...state, productDescription: action.payload };
        case 'PRODUCT_LINK_CHANGE':
            return { ...state, productLink: action.payload };
        case 'PRODUCT_PICTURE_LINK_CHANGE':
            return { ...state, productPictureLink: action.payload };
        case 'PRODUCT_MESSAGE_CHANGE':
            return { ...state, productMessage: action.payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Products/ProductReducer.js